import React from 'react'
import { AumHeatmapChart } from './AumHeatmap'
import { resolveClientSegmentSubtitleLabel } from './NetFlowsHeatmapShared'

const AumAssetClassAndGeographyHeatmap = (props) => (
  <AumHeatmapChart
    {...props}
    rowAxisLabel="Geography"
    resolveFilterSubtitleLabel={resolveClientSegmentSubtitleLabel}
    accessibilityPointDescription="{series.xAxis.categories.(x)} asset class AUM {series.yAxis.categories.(y)} geography, {value}."
  />
)

export default AumAssetClassAndGeographyHeatmap
